module.exports = __webpack_public_path__ + "static/img/3.90cc039.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/3.png
// module id = tM8G
// module chunks = 0